/* src/app/order/components/billing-information/billing-info-edit/billing-preferences/billing-preferences.style.scss */
.billing-preferences {
  margin-top: 20px;
}
.billing-preferences .radio-row {
  flex-wrap: nowrap;
  flex-direction: column;
  padding: 20px 0 20px 0;
}
.billing-preferences .radio-row nb-radio-group {
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
}
.billing-preferences .radio-row nb-radio-group nb-radio {
  display: inline-block;
}
.billing-preferences .radio-row .radio-with-question {
  display: flex;
  flex-wrap: nowrap;
  align-items: baseline;
}
.billing-preferences .radio-row .radio-column {
  min-width: 80px;
}
.billing-preferences .text-row .text-row-label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
}
.billing-preferences .text-row .additional-billing-info {
  margin: 0;
}
.billing-preferences .text-row .optional-label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  text-align: right;
  color: #8C8C8C;
  margin-left: auto !important;
  vertical-align: middle;
  text-align: right;
  float: right;
}
.billing-preferences .purchase-label {
  display: block;
}
@media screen and (max-width: 767px) {
  .radio-with-question {
    flex-direction: column-reverse;
  }
}
/*# sourceMappingURL=billing-preferences.style.css.map */
